"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseInstrumentation = void 0;
/**
 * Base instrumentation class for class-level logging (no request context)
 * This class provides a generic implementation that can be extended
 * for specific logger implementations (Fastify, Pino, etc.)
 */
class BaseInstrumentation {
    logger;
    serviceName;
    constructor(config) {
        this.logger = config.logger;
        this.serviceName = config.serviceName;
    }
    /**
     * Get a unique identifier for this service
     */
    getServiceId() {
        return this.serviceName;
    }
    /**
     * Build a formatted message with the service ID
     */
    buildMessage(message) {
        return `[${this.getServiceId()}] ${message}`;
    }
    /**
     * Build the arguments object for logging
     */
    buildArguments(args) {
        const baseArgs = {
            serviceId: this.getServiceId(),
            serviceName: this.serviceName,
        };
        if (args !== undefined && args !== null) {
            if (typeof args === "object") {
                Object.assign(baseArgs, args);
            }
            else {
                baseArgs.data = args;
            }
        }
        return baseArgs;
    }
    /**
     * Log informational message
     */
    logInfo(message, data) {
        this.logger.info(this.buildArguments(data), this.buildMessage(message));
    }
    /**
     * Log a warning
     */
    logWarning(message, data) {
        this.logger.warn(this.buildArguments(data), this.buildMessage(message));
    }
    /**
     * Log debug information
     */
    logDebug(message, data) {
        this.logger.debug(this.buildArguments(data), this.buildMessage(message));
    }
    /**
     * Log an error that occurred
     */
    logErrorOccurred(error, extraArgsOrMessage, message) {
        const errorMessage = error instanceof Error ? error.message : String(error);
        // Handle the case where extraArgsOrMessage is a string (backward compatibility)
        let extraArgs = {};
        let finalMessage = message ?? "Service failed";
        if (typeof extraArgsOrMessage === "string") {
            finalMessage = extraArgsOrMessage;
        }
        else if (extraArgsOrMessage) {
            extraArgs = extraArgsOrMessage;
        }
        this.logger.error(this.buildArguments({
            error: errorMessage,
            rawError: JSON.stringify(error),
            ...extraArgs,
        }), this.buildMessage(finalMessage));
    }
}
exports.BaseInstrumentation = BaseInstrumentation;
//# sourceMappingURL=BaseInstrumentation.js.map